import React from "react";
import { Link } from "react-router-dom";

import logo from "../Images/brand/logo.png"
import compoundImg from "../Images/virtuous_database_search.png"

function FoodDatabase() {
    return <section className="flex flex-col h-full antialiased bg-neutral-800">
        <header className="sticky top-0 z-50 bg-white md:px-24 drop-shadow-md">
            <div className="flex flex-col items-center justify-between gap-4 p-5 md:flex-row">
                <a href="/">
                    <img className="w-40" src={logo} alt="Virtuous LOGO" />
                </a>
                <a href="/" className="flex items-center gap-4 cta cta-primary">
                <p>All tools</p>
                <i className="ph-caret-right"></i>
                </a>
            </div>
        </header>

        <main
        className="container relative flex flex-col flex-auto gap-8 p-8 mx-auto my-8 md:p-10 card">
        {/*Action Top*/}
        <div className="flex items-center gap-4">
            <img src={compoundImg} alt="Virtuous Compounds"
                className="w-40 h-40 p-4 bg-gray-100 rounded-full" />
            <div>
                <h1 className="font-bold uppercase ">Virtuous Database Search</h1>
                <p className="text-gray-500">Dynamic and interactive exploration of the FooDB (<a href="https://foodb.ca" className="link" target="_blank">foodb.ca</a>)</p>
            </div>
        </div>
        {/*List*/}

        
        <div className="flex justify-between">
            <button
                className="text-white bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center"
                type="button">Food group <i className="ph-caret-down"></i></button>
    
            {/*dx*/}
            <form className=" md:w-1/2">
                <label htmlFor="search" className="mb-2 text-sm font-medium text-gray-900 sr-only">Search foods</label>
                <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg aria-hidden="true" className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg>
                    </div>
                    <input type="search" id="search"
                        className="block w-full p-4 pl-10 text-sm text-gray-900 placeholder-gray-400 border border-gray-600 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500"
                        placeholder="Write a food or category" required />
                    <button type="submit"
                        className="text-white absolute right-2.5 bottom-2.5 focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm px-4 py-2 bg-primary-600 hover:bg-primary-700 focus:ring-primary-800">Search</button>
                </div>
            </form>
                
        </div>
       
        
        <div className="grid gap-4 p-4 bg-gray-100 rounded-3xl ">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table className="w-full text-sm text-left text-primary-100 dark:text-primary-100">
                    <thead className="text-xs text-white uppercase bg-primary-600 dark:text-white">
                        <tr>
                            <th scope="col" className="px-6 py-3"> ID </th>
                            <th scope="col" className="px-6 py-3"> Name </th>
                            <th scope="col" className="px-6 py-3"> Scientific name </th>
                            <th scope="col" className="px-6 py-3"> Food group </th>
                            <th scope="col" className="px-6 py-3"> Food subgroup </th>
                            <th scope="col" className="px-6 py-3 text-right"></th>
                        </tr>
                    </thead>
                    <tbody className="text-lg font-bold text-white">
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 01 </th>
                            <td className="px-6 py-4"> Angelica </td>
                            <td className="px-6 py-4"> Angelica keiskei </td>
                            <td className="px-6 py-4"> Herbs and Spices </td>
                            <td className="px-6 py-4"> Herbs </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                                <Link to="/details/Angelica" className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more
                                </Link>
                            </td>
                        </tr>

                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 02 </th>
                            <td className="px-6 py-4"> Savoy cabbage </td>
                            <td className="px-6 py-4"> Brassica oleracea var. sabauda </td>
                            <td className="px-6 py-4"> Vegetables </td>
                            <td className="px-6 py-4"> Cabbages </td>
                            <td className="px-6 py-4 text-right">
                                <Link to="/details/Savoy-cabbage"
                                    className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more </Link>
                            </td>
                        </tr>

                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 03 </th>
                            <td className="px-6 py-4"> Silver linden </td>
                            <td className="px-6 py-4"> Tilia argentea </td>
                            <td className="px-6 py-4"> Herbs and Spices </td>
                            <td className="px-6 py-4"> Herbs </td>
                            <td className="px-6 py-4 text-right">
                                <Link to="/details/Silver-linden"
                                    className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 04 </th>
                            <td className="px-6 py-4"> Kiwi </td>
                            <td className="px-6 py-4"> Actinidia chinensis </td>
                            <td className="px-6 py-4"> Fruits </td>
                            <td className="px-6 py-4"> Tropical fruits </td>
                            <td className="px-6 py-4 text-right">
                                <Link to="/details/Kiwi"
                                    className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 05 </th>
                            <td className="px-6 py-4"> Allium </td>
                            <td className="px-6 py-4"> Allium </td>
                            <td className="px-6 py-4"> Vegetables </td>
                            <td className="px-6 py-4"> Onion-family vegetables </td>
                            <td className="px-6 py-4 text-right">
                                <Link to="/details/Allium"
                                    className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 06 </th>
                            <td className="px-6 py-4"> Garden onion </td>
                            <td className="px-6 py-4"> Allium cepa </td>
                            <td className="px-6 py-4"> Vegetables </td>
                            <td className="px-6 py-4"> Onion-family vegetables </td>
                            <td className="px-6 py-4 text-right">
                                <a href="#"
                                    className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more </a>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 07 </th>
                            <td className="px-6 py-4"> Leek </td>
                            <td className="px-6 py-4"> Allium porrum </td>
                            <td className="px-6 py-4"> Vegetables </td>
                            <td className="px-6 py-4"> Onion-family vegetables </td>
                            <td className="px-6 py-4 text-right">
                                <a href="#"
                                    className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more </a>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 08 </th>
                            <td className="px-6 py-4"> Garlic </td>
                            <td className="px-6 py-4"> Allium sativum </td>
                            <td className="px-6 py-4"> Herbs and Spices </td>
                            <td className="px-6 py-4"> Herbs </td>
                            <td className="px-6 py-4 text-right">
                                <a href="#"
                                    className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more </a>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 09 </th>
                            <td className="px-6 py-4"> Chives </td>
                            <td className="px-6 py-4"> Allium schoenoprasum </td>
                            <td className="px-6 py-4"> Herbs and Spices</td>
                            <td className="px-6 py-4"> Herbs </td>
                            <td className="px-6 py-4 text-right">
                                <a href="#"
                                    className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more </a>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <th scope="row" className="px-6 py-4 whitespace-nowrap "> 10 </th>
                            <td className="px-6 py-4"> Lemon verbena </td>
                            <td className="px-6 py-4"> Aloysia triphylla </td>
                            <td className="px-6 py-4"> Herbs and Spices</td>
                            <td className="px-6 py-4"> Herbs </td>
                            <td className="px-6 py-4 text-right">
                                <a href="#"
                                    className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth">
                                    show more </a>
                            </td>
                        </tr>
                       
                    </tbody>
                </table>
            </div>
        </div>
        {/*Action bottom*/}
        <div className="mx-auto">
            <nav aria-label="Page navigation example">
                <ul className="inline-flex -space-x-px">
                    <li>
                        <a href="#"
                            className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700">Previous</a>
                    </li>
                    <li>
                        <a href="#" aria-current="page"
                            className="px-3 py-2 leading-tight border border-gray-300 text-primary-600 bg-primary-50 hover:bg-gray-100 hover:text-gray-700">1</a>
                    </li>
                    <li>
                        <a href="#"
                            className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">2</a>
                    </li>
                    <li>
                        <a href="#" 
                            className="px-3 py-2 text-gray-500 bg-white border border-gray-300 hover:bg-primary-100 hover:text-primary-700">3</a>
                    </li>
                    <li>
                        <a href="#"
                            className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700">4</a>
                    </li>
                    <li>
                        <a href="#"
                            className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700">5</a>
                    </li>
                    <li>
                        <a href="#"
                            className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700">Next</a>
                    </li>
                </ul>
            </nav>
        </div>
    </main> 

    </section>
}

export default FoodDatabase;